"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.excel = void 0;
var utils_1 = require("../../utils");
exports.excel = function (axios) {
    return {
        getExcels: function (getExcelsRequest) {
            return axios.get('/excels', getExcelsRequest);
        },
        postExcels: function (postExcelsRequest) {
            return axios.post('/excels', postExcelsRequest.data);
        },
        postExcelsCompressDownload: function (postExcelsCompressDownloadsRequest) {
            axios.defaults.timeout = 30 * 60 * 1000; // 1800 second
            return axios.post('/excels/compress-download', postExcelsCompressDownloadsRequest.data, { responseType: 'blob' })
                .then(function (res) {
                return res;
            })
                .finally(function () {
                axios.defaults.timeout = 30 * 1000;
            });
        },
        putExcelsCancel: function (putExcelsCancelRequest) {
            var url = utils_1.paramPathchange('/excels/{excelNo}/cancel', putExcelsCancelRequest);
            return axios.put(url);
        }
    };
};
